import { createReducer } from '@reduxjs/toolkit';
import { loadPaymentMethods } from '../../actions/loadPaymentMethods';
import { type ExpressPaymentMethods } from '../../types/PaymentMethods';
import { getPaymentMethodsFromResponse } from './dataMappers';

const initialState: ExpressPaymentMethods = [];

export const paymentMethodsReducer = createReducer(initialState, (builder) => {
  builder.addCase(loadPaymentMethods.fulfilled, (_state, action) => {
    return getPaymentMethodsFromResponse(action.payload);
  });
});
